export default {
  common: {
    back: "返回",
    cancel: "取消",
    submit: "提交",
    loading: "拼命加载中",
    noData: "暂无数据",
    copySuccess: "复制成功",
  },
  index: {
    title: "AI模型",
    cards: {
      gasfee: {
        title: "首笔手续费追溯",
        desc: "追溯单个地址5级之内的交易所地址",
      },
      multilayer: {
        title: "多层追溯",
        desc: "追溯流单个地址最多3级之内的转入或者转出交易路径",
      },
      transactionpath: {
        title: "交易路径分析",
        desc: "分析2级内多个起始地址到终点地址中的途径点和交易路径",
      },
      associatedGasFee: {
        title: "关联手续费追溯",
        desc: "一键锁定手续费关联的可调证地址",
      },
      tornado: {
        title: "龙卷风模型",
        desc: "智能穿透追踪混币平台数据，支持双向溯源",
      },
      newOldStop: {
        title: "新启旧停模型",
        desc: "自动追踪黑灰产资金从旧地址到新地址的迁移链路",
        tooltip:
          "新启旧停模型用于分析黑灰产地址的迁移行为。用户可指定目标地址与筛选条件，系统将自动检索该地址的最早或最新一笔交易，识别地址启用或停用状态。模型可发现黑灰产在更换收款地址时的整笔资金转移，有助于追踪其最新活跃地址或反向查找历史地址，为链上追踪与风险分析提供关键线索。",
      },
      singleChannel: {
        title: "单通道中转模型",
        desc: "自动追踪其上/下游资金流动，识别单通道的中转链路",
        tooltip:
          "该模型用于识别黑灰产资金转移过程中的中转行为。系统会以指定地址为起点，逐层分析其资金流入和流出关系，寻找资金流高度集中的地址链路。模型会沿着这类高依赖的转移路径持续追踪，直到资金出现分散流动，从而揭示黑灰产资金的主要中转路径。",
      },
    },
  },
  gasfee: {
    title: "首笔手续费追溯",
    empty: {
      title: "暂无数据",
      tip: "请在画布中选择节点后右键或者点击顶部AI模型下的按钮选择首笔手续费追溯",
    },
    basicInfo: {
      verifyType: "模型验证类型",
      feeModel: "手续费模型",
    },
    result: {
      titlePrefix: "分析结果:",
      firstSourceLevel: "首笔手续费来源层级",
      sourceLevel: "手续费来源层级",
      firstSourcePlatform: "首笔手续费来源平台",
      firstSourceAddress: "首笔手续费来源地址",
      sourceAddress: "手续费来源地址",
      firstSourceHash: "首笔手续费来源hash",
      sourceHash: "手续费来源hash",
      firstSourceTime: "首笔手续费来源时间",
      sourceTime: "手续费来源时间",
      firstSourceQuantity: "首笔手续费来源数量",
      sourceQuantity: "手续费来源数量",
    },
    survey: {
      add: "添加调证",
      normal: "普通调证",
      important: "重点调证",
    },
  },
  multilayer: {
    title: "多层追溯",
    form: {
      addressLabel: "分析地址",
      addressPlaceholder: "请输入地址",
      currencyLabel: "币种选择",
      currencyPlaceholder: "请选择币种",
      directionLabel: "方向",
      directionPlaceholder: "请选择方向",
      directionOptions: {
        OUTFLOW: "流出",
        INFLOW: "流入",
      },
      levelLabel: "关联层级",
      levelPlaceholder: "请选择层级",
      cancel: "取消",
      submit: "提交",
    },
    result: {
      analysisAddress: "[分析地址]",
      calculationCurrency: "[计算币种]",
      analysisBanner: "分析结果: 已经追溯到{count}条交易路径",
      graphAnalysis: "上图分析",
      level: "层级:",
      tag: "标签:",
      levelTotalQuantityDesc: "当前路径的{depth}级交易总数量",
      outflow: "转出",
      inflow: "转入",
      traceTo: "追溯至:",
      levelUnit: "级",
      levelTransaction: "级交易数量",
    },
  },
  transactionpath: {
    title: "交易路径分析",
    form: {
      fromAddressLabel: "起始地址",
      multiTip: "多个地址请换行(ctrl/⌘+回车)隔开",
      fromAddressPlaceholder: "请输入地址，最多输入5个地址",
      toAddressLabel: "终点地址",
      toAddressPlaceholder: "请输入地址，最多输入5个地址",
      swapTip: "起始/终点位置交换",
      currencyTypeLabel: "币种类型",
      currencyPlaceholder: "请选择币种",
      associationLabel: "关联层级",
      associationPlaceholder: "请选择活动区域",
      cancel: "取消",
      submit: "提交",
      validators: {
        currencyRequired: "请选择币种",
        fromRequired: "请输入起始地址",
        toRequired: "请输入终点地址",
        maxFive: "最多只能输入5个地址",
      },
      clear: "清空",
    },
  },
  transactiontabel: {
    title: "交易路径分析",
    summary: {
      startAddresses: "[起始地址]",
      endAddresses: "[终点地址]",
      completionTime: "[完成时间]",
      calculationCurrency: "[计算币种]",
      calculationLevel: "[计算层级]",
    },
    result: {
      summary: "分析结果：{pathCount}条交易路径，涉及途径地址{wayPointCount}个",
    },
    table: {
      waypoint: "途径点",
      totalInflow: "累计流入",
      totalOutflow: "累计流出",
      ioTip:
        "途径地址的累计流入/流出交易数据，仅统计符合条件的交易路径中的交易数据",
      txCount: "交易笔数",
      txCountTip: "流入笔数/流出笔数",
      action: "操作",
      graphAnalysis: "上图分析",
      empty: "暂无数据",
    },
  },
  alternation: {
    newOldStop: "新启旧停模型",
    singleChannel: "单通道中转模型",
    form: {
      addressLabel: "分析地址",
      addressPlaceholder: "请输入地址",
      currencyLabel: "币种选择",
      currencyPlaceholder: "请选择币种",
      directionLabel: "方向",
      directionPlaceholder: "请选择方向",
      directionOptions: {
        INFLOW: "流入",
        OUTFLOW: "流出",
      },
      amountLabel: "交易金额",
      levelLabel: "追溯最大层级",
      levelPlaceholder: "请选择层级",
      levelRange: "关联层级必须在1-20之间",
      endTimeLabel: "追溯截止时间",
      endTimePlaceholder: "选择日期时间",
    },
    history: {
      add: "新增",
      direction: "方向：",
      submitTime: "提交时间：",
      status: {
        computing: "计算中",
        success: "计算成功",
        failed: "计算失败",
      },
    },
    result: {
      computing: "正在计算中",
      computingTip: "请等待成功后再查看详情",
      failed: "计算失败",
      failedTip: "系统异常，可稍后重试",
      calculateAddress: "[计算地址]",
      completionTime: "[完成时间]",
      calculationCurrency: "[计算币种]",
      calculationDirection: "[计算方向]",
      analysisBanner: "分析结果：涉及关联地址{count}个",
      graphAnalysis: "上图分析",
      relatedAddress: "关联地址",
      level: "层级",
      amount: "金额",
      time: "时间",
      action: "操作",
      dataDetail: "数据明细",
    },
    messages: {
      computingNotice: "正在计算中，请等待成功后再查看详情",
      addFailed: "新增失败",
    },
  },
};
